module.exports = __webpack_public_path__ + "img/columbias2.ace0ec74.jpeg";